import { useLayoutEffect, useState } from "react";

export type DeviceType = "mobile" | "tablet" | "desktop";

const useDeviceDetection = (): DeviceType | null => {
    const [device, setDevice] = useState<DeviceType | null>(null);

    // layout effect so the desktop QR column is there before the first paint instead of popping in
    useLayoutEffect(() => {
        if (!window) return;

        const handleDeviceDetection = () => {
            const userAgent = navigator.userAgent.toLowerCase();
            const isMobile = /iphone|ipad|ipod|android|blackberry|windows phone/g.test(userAgent);
            const isTablet = /(ipad|tablet|playbook|silk)|(android(?!.*mobile))/g.test(userAgent);

            if (isMobile) {
                setDevice("mobile");
            } else if (isTablet) {
                setDevice("tablet");
            } else {
                setDevice("desktop");
            }
        };

        handleDeviceDetection();
        window.addEventListener("resize", handleDeviceDetection);

        return () => {
            window.removeEventListener("resize", handleDeviceDetection);
        };
    }, []);

    return device;
};

export default useDeviceDetection;
